app.component("insertion", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/graftInsertion/insertion.html",
	controller: "insertionController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("insertionController", [
	"$scope",
	function ($scope) {
		$scope.options = [
			{ name: "Glide", model: "is_insertion_glide"},
			{ name: "IOL Injector", model: "is_insertion_iol_injector" },
			{ name: "Forceps", model: "is_insertion_forceps" },
			{ name: "Suture Pull-through", model: "is_insertion_suture_pull_through" },
            { name: "Manual Fold", model: "is_insertion_manual_fold" },
			{ name: "Other (specify)", model: "other" },
		];

		this.$onInit = function () {};

        $scope.isRequired = () => {
			return (
				!$scope.$ctrl.data.insertion.is_insertion_glide &&
				!$scope.$ctrl.data.insertion.is_insertion_iol_injector &&
				!$scope.$ctrl.data.insertion.is_insertion_forceps &&
				!$scope.$ctrl.data.insertion.is_insertion_suture_pull_through &&
                !$scope.$ctrl.data.insertion.is_insertion_manual_fold &&
				!$scope.$ctrl.data.insertion.other
			);
		};
	},
]);